import { EtxeApiPrefixes, EtxeApiSlugs, PublicUserProfileDto } from '@workspace/data-types';
import { Observable } from 'rxjs';
import { ApiCaller } from '../../../../../api-caller.service';

export class PublicUsersConnector {
  private slug = EtxeApiSlugs.USERS;

  constructor(
    private apiCaller: ApiCaller,
    private prefix: string,
  ) {}

  get(userId: string, params?: { role?: string }): Observable<PublicUserProfileDto> {
    return this.apiCaller.getRequest<PublicUserProfileDto>(EtxeApiPrefixes.PUBLIC, `${this.slug}/${userId}`, {
      params,
    });
  }
}
